export default __webpack_public_path__ + "static/media/650.5a2e66b2.jpg";